/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Panel, PanelBody, PanelHeader } from '../../../util/panel';
import { Button, Table } from 'antd';
import { FaPen, FaPlus } from 'react-icons/fa';
import { RiFileListLine } from 'react-icons/ri';
import { RiUserReceivedLine } from 'react-icons/ri';
import { MdDelete } from 'react-icons/md';
import usePaginationHook from '../../../../utils/usePagination';
import { useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { AlertConfirm } from '../../../util/Alert';
import { FormProvider, useForm } from 'react-hook-form';
import 'dayjs/locale/th';
import LegacyMissionModal from '../components/modal/LegacyMissionModal';
import LegacyMissionMemberListModal from '../components/modal/LegacyMissionMemberListModal';
import LegacyMissionReceivableMemberListModal from '../components/modal/LegacyMissionReceivableMemberListModal';
import {
  legacyMissionFormDefaultValues,
  legacyMissionFormSchema,
} from '../components/dto/legacy-mission-form.dto';
import fitMissionServices from '../../../../services/fit-mission.services';
import { useClipboard } from 'use-clipboard-copy';

dayjs.locale('th');

const pageSize = 10;

const LegacyMissionPage = () => {
  const [legacyMissionFormOpen, setLegacyMissionFormOpen] = useState(false);
  const [legacyMissionMemberListOpen, setLegacyMissionMemberListOpen] =
    useState(false);
  const [
    legacyMissionReceivableMemberListOpen,
    setLegacyMissionReceivableMemberListOpen,
  ] = useState(false);
  const [mission, setMission] = useState(undefined);

  const {
    data: legacyMissionLists,
    setData,
    page,
    setPage,
    total,
    setTotal,
  } = usePaginationHook();
  const queryClient = useQueryClient();
  const clipboard = useClipboard();

  const legacyMissionForm = useForm({
    defaultValues: legacyMissionFormDefaultValues,
    resolver: legacyMissionFormSchema(),
  });

  const _HandleLegacyMissionFormOpen = (formType) => {
    legacyMissionForm.setValue('formType', formType);
    setLegacyMissionFormOpen(true);
  };

  const _HandleLegacyMissionFormClose = () => {
    legacyMissionForm.reset(legacyMissionFormDefaultValues);
    setLegacyMissionFormOpen(false);
  };

  fitMissionServices.useQueryGetMissionLists(
    { take: pageSize, page },
    (data) => {
      setData(data.data);
      setTotal(data.meta.total);
    },
  );

  const { mutate: deleteMission } = fitMissionServices.useMutationDeleteMission(
    () => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission'],
        refetchType: 'all',
      });
    },
  );

  const columns = [
    {
      title: 'NO',
      dataIndex: 'index',
      key: 'index',
      render: (_, record, index) => (
        <span>{(page - 1) * pageSize + index + 1}</span>
      ),
    },
    // {
    //   title: 'ID',
    //   dataIndex: 'ID',
    //   key: 'ID',
    //   render: (_, record, index) => (
    //     <div
    //       onClick={(e) => {
    //         e.stopPropagation();
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: 'flex',
    //           alignItems: 'center',
    //           cursor: 'pointer',
    //           marginBottom: 10,
    //         }}
    //         onClick={() => {
    //           clipboard.copy(record.id);
    //         }}
    //       >
    //         <FaCopy style={{ fontSize: 18 }} />
    //         <span className="ml-2">คัดลอก ID {record.id}</span>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      title: 'รูปภาพ',
      dataIndex: 'image',
      key: 'image',
      render: (_, record) => (
        <div
          style={{
            width: 200,
            height: 100,
          }}
        >
          {record.image && (
            <img
              alt={record.title}
              src={record.image}
              style={{
                width: 200,
                height: 100,
                objectFit: 'cover',
              }}
            />
          )}
        </div>
      ),
    },
    {
      title: 'หัวข้อ',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => <span>{record.title}</span>,
      width: 250,
    },
    {
      title: 'คำอธิบาย',
      dataIndex: 'description',
      key: 'description',
      render: (_, record) => (
        <span>
          {record.description && record.description.length > 200
            ? record.description.slice(0, 200) + '...'
            : record.description}
        </span>
      ),
      width: 250,
    },
    {
      title: 'สิทธิ์การเห็น',
      dataIndex: 'memberType',
      key: 'memberType',
      render: (_, record) => (
        <span>
          {record.memberType === 'All' && 'ทั้งหมด'}
          {record.memberType === 'Distributor' && 'เฉพาะนักธุรกิจ'}
          {record.memberType === 'Member' && 'เฉพาะ VIP Member'}
          {record.memberType === 'Group' && 'เฉพาะรายชื่อ'}
        </span>
      ),
    },
    {
      title: 'จำนวนรหัสทั้งหมด',
      dataIndex: 'memberListCount',
      key: 'memberListCount',
      render: (_, record) => (
        <span>
          {record.memberType === 'Group' ? record.memberListTotal || 0 : '-'}
        </span>
      ),
      align: 'center',
    },
    {
      title: 'จำนวนรหัสมีสิทธิ์กดรับ',
      dataIndex: 'receivableMemberListCount',
      key: 'receivableMemberListCount',
      render: (_, record) => (
        <span>{record.receivableMemberListTotal || 0}</span>
      ),
      align: 'center',
    },
    {
      title: 'วันที่เริ่ม',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (_, record) => (
        <span>{dayjs(record.startDate).format('DD/MMM/YYYY เวลา HH:mm')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.startDate).diff(dayjs(b.startDate), 'D') > 0 ? 1 : -1,
    },
    {
      title: 'วันที่สิ้นสุด',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (_, record) => (
        <span>{dayjs(record.endDate).format('DD/MMM/YYYY เวลา HH:mm')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.endDate).diff(dayjs(b.updatedAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: 'คะแนนที่ได้รับ',
      dataIndex: 'point',
      key: 'point',
      render: (_, record) => <span>{record.point}</span>,
    },
    {
      title: 'อัปเดตเมื่อ',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (_, record) => (
        <span>{dayjs(record.updatedAt).format('DD/MMM/YYYY')}</span>
      ),
      sorter: (a, b) =>
        dayjs(a.updatedAt).diff(dayjs(b.updatedAt), 'D') > 0 ? 1 : -1,
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{ display: 'flex', justifyContent: 'flex-end' }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {record.memberType === 'Group' && (
            <div
              style={{ cursor: 'pointer', marginLeft: 10 }}
              onClick={() => {
                setMission(record);
                setLegacyMissionMemberListOpen(true);
              }}
            >
              <RiFileListLine />
            </div>
          )}
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              setMission(record);
              setLegacyMissionReceivableMemberListOpen(true);
            }}
          >
            <RiUserReceivedLine />
          </div>
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={() => {
              legacyMissionForm.setValue('id', record.id);
              _HandleLegacyMissionFormOpen('edit');
            }}
          >
            <FaPen />
          </div>
          <div
            style={{ cursor: 'pointer', marginLeft: 10 }}
            onClick={async () => {
              const confirm = await AlertConfirm('ลบข้อมูล');
              if (confirm) deleteMission({ id: record.id });
            }}
          >
            <MdDelete />
          </div>
        </div>
      ),
    },
  ];

  return (
    <Panel>
      <PanelHeader>ภารกิจ</PanelHeader>
      <PanelBody>
        <div style={{ display: 'flex', alignItems: 'center' }} className="mb-2">
          <div style={{ flex: 1 }} />
          <Button
            onClick={() => {
              _HandleLegacyMissionFormOpen('create');
            }}
            type="primary"
          >
            <FaPlus className="mr-2" />
            เพิ่มภารกิจ
          </Button>
        </div>
        <Table
          columns={columns}
          dataSource={legacyMissionLists}
          style={{ backgroundColor: '#fff' }}
          rowKey="id"
          scroll={{ x: 'max-content' }}
          onChange={({ current }) => {
            setPage(current);
          }}
          pagination={{
            pageSize,
            total,
          }}
        />
      </PanelBody>
      <FormProvider {...legacyMissionForm}>
        <LegacyMissionModal
          open={legacyMissionFormOpen}
          handleClose={_HandleLegacyMissionFormClose}
        />
      </FormProvider>
      {mission && (
        <LegacyMissionMemberListModal
          open={legacyMissionMemberListOpen}
          handleClose={() => {
            setMission(undefined);
            setLegacyMissionMemberListOpen(false);
          }}
          mission={mission}
        />
      )}
      {mission && (
        <LegacyMissionReceivableMemberListModal
          open={legacyMissionReceivableMemberListOpen}
          handleClose={() => {
            setMission(undefined);
            setLegacyMissionReceivableMemberListOpen(false);
          }}
          mission={mission}
        />
      )}
    </Panel>
  );
};

export default LegacyMissionPage;
